import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import { Fab, Action } from 'react-tiny-fab';
import 'react-tiny-fab/dist/styles.css';
import AddIcon from '@material-ui/icons/Add';
import CreateIcon from '@material-ui/icons/Create';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import CropLandscapeIcon from '@material-ui/icons/CropLandscape';
import AddClient from '../Clients/AddClient';
import AddVendor from '../Vendors/AddVendor';
import AddMetal from '../Metals/AddMetal';
import AddShipping from '../Shipping/AddShipping';

const FabButton = () => {

  const location = useLocation()
  const mainButtonStyles = {backgroundColor: '#1976D2'}
  const [open, setOpen] = useState(false)
  const [openVendor, setOpenVendor] = useState(false)
  const [openMetal, setOpenMetal] = useState(false)
  const [openShipping, setOpenShipping] = useState(false)
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')))

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem('profile')))
  }, [location])

  // if(location.pathname === '/invoice') return null

    return (
        <div>
           <AddClient setOpen={setOpen} open={open} />
           <AddVendor setOpenVendor={setOpenVendor} openVendor={openVendor} />
           <AddMetal setOpenMetal={setOpenMetal} openMetal={openMetal} />
           <AddShipping setOpenShipping={setOpenShipping} openShipping={openShipping} />
          <Fab
            mainButtonStyles={mainButtonStyles}
            icon={ <AddIcon />}
            alwaysShowTitle={true}
          >

            {location.pathname !== '/invoice' && (
              <Action
                  text="New Invoice"
                  onClick={() => window.location.href='/invoice'}
                >
                  <CreateIcon />
              </Action>
            )}
           {user && user.result && (user.result.role.role != 'Operator') && (
            <>
            <Action
                text="New Customer"
                onClick={() => setOpen((prev) => !prev)}
              >
                <PersonAddIcon />
            </Action>

            <Action
                text="New Vendor"
                onClick={() => setOpenVendor((prev) => !prev)}
              >
                <PersonAddIcon />
            </Action>

            <Action
                text="New Metal"
                onClick={() => setOpenMetal((prev) => !prev)}
              >
                <CropLandscapeIcon />
            </Action>

            <Action
                text="New Shipping"
                onClick={() => setOpenShipping((prev) => !prev)}
              >
                <CropLandscapeIcon />
            </Action>

            <Action 
                text="New Inventory"
                onClick={() => window.location.href='/inventory'}
              >
                <CropLandscapeIcon />
            </Action>
           </>)}
          </Fab>
        </div>
    )
}

export default FabButton
